import { backgroundImageStyles } from "./shared";

export const Row = {
  componentId: "Row",
  resources: [
    {
      id: "label",
      label: "Reference Label",
      componentId: "Input",
      section: "content",
      hint: "An internal label for your own reference only.",
    },
    {
      id: "gap",
      label: "Item Spacing",
      hint: "The space between the items in the row",
      section: "spacing",
      componentId: "Input",
      type: "number",
      defaultValue: 20,
      isStyle: true,
      orientation: "horizontal",
      width: "120px",
    },
    ...backgroundImageStyles,
    {
      id: "flexWrap",
      label: "Allow Row Wrapping",
      hint: "Allow the row to wrap onto multiple lines to be responsive on different screen sizes",
      section: "spacing",
      componentId: "Switch",
      defaultValue: false,
      isStyle: true,
      orientation: "horizontal",
    },
    {
      id: "blockHierarchy",
      hint: "Configure the blocks inside this Row",
      section: "blocks",
      componentId: "BlockHierarchy",
    },
    {
      id: "horizontalAlignment",
      label: "Horizontal Alignment",
      hint: "Define how the items align horizontally",
      section: "spacing",
      componentId: "SelectToggle",
      defaultValue: "flex-start",
      isStyle: true,
      tabs: [
        {
          label: "Start",
          value: "flex-start",
          icon: "Custom-VAlignBottom",
          rotate: 90,
        },
        {
          label: "Center",
          value: "center",
          icon: "Custom-VAlignCenter",
          rotate: 90,
        },
        {
          label: "End",
          value: "flex-end",
          icon: "Custom-VAlignTop",
          rotate: 90,
        },
        {
          label: "Space Between",
          value: "space-between",
          icon: "Custom-VSpaceBetween",
          rotate: 90,
        },
        {
          label: "Space Around",
          value: "space-around",
          icon: "Custom-VSpaceAround",
          rotate: 90,
        },
      ],
    },
    {
      id: "verticalAlignment",
      label: "Vertical Alignment",
      hint: "Define how the items align vertically. Note: This only matters if your items have different heights.",
      section: "spacing",
      defaultValue: "flex-start",
      componentId: "SelectToggle",
      isStyle: true,
      tabs: [
        {
          label: "Start",
          value: "flex-start",
          icon: "Custom-VAlignTop",
        },
        {
          label: "Center",
          value: "center",
          icon: "Custom-VAlignCenter",
        },
        {
          label: "End",
          value: "flex-end",
          icon: "Custom-VAlignBottom",
        },
        { label: "Stretch", value: "stretch", icon: "Custom-VAlignStretch" },
      ],
    },
    {
      id: "clickAction",
      label: "Click Action",
      componentId: "Action",
      section: "actions",
      isAction: true,
    },
    {
      id: "switchToColumn",
      componentId: "SwitchComponent",
      type: "Column",
      section: "switchToColumn",
    },
  ],
};
